<!--未返程单据-->
<template>
  <div>
    <el-button
      size="small"
      type="danger"
      @click="onNotReturnQuery"
    >{{ $t('receivablePayable.notReturnQuery') }}</el-button>

    <el-dialog
      :title="$t('receivablePayable.notReturnQuery')"
      :visible.sync="dialogVisible"
      width="80%"
      @close="handleDialogClose"
    >
      <div class="feet-r mb10">
        <span class="title">{{ $t('basicData.TransportOrderNumber') }}:</span>
        <el-input
          v-model="orders" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
          :placeholder="$t('receivablePayable.notReturnQueryTip')"
          style="width: 400px"
        />
        <el-button
          size="small" type="primary"
          @click="onSearch"
        >{{ $t('GlobalSetObj.search') }}</el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="tableData"
        border
        height="300"
        element-loading-text="加载中..."
        element-loading-background="rgba(255, 255, 255, 0.7)"
      >
        <!-- 运输时间 -->
        <el-table-column prop="transportDateTime" :label="$t('trajectory.TransitTime')" />
        <!-- 运输单号 -->
        <el-table-column prop="transportNumber" :label="$t('basicData.TransportOrderNumber')" />
        <!-- 司机 -->
        <el-table-column prop="driverName" :label="$t('GlobalSetObj.driver')" />
        <!-- 车辆类型 -->
        <el-table-column prop="vehicleTypeStr" :label="$t('collectionCenter.carType')" />
        <!-- 车线名称 -->
        <el-table-column prop="lineName" :label="$t('basicData.routeName')" />
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page="pageNumber"
          :page-size="pageSize"
          :page-sizes="[20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="onCurrentChange"
          @size-change="onSizeChange"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiPayableTransportExpenseGetUnreturnedTransportOrders } from '@/api/finance/receivables';
export default {
  name: 'OneWayDialog',

  data() {
    return {
      dialogVisible: false,
      loading: false,
      orders: '', // 订单号
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      tableData: []
    };
  },

  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          this.onSearch();
        }
      }
    }
  },

  methods: {
    onNotReturnQuery() {
      this.dialogVisible = true;
    },
    onSearch() {
      this.getList();
    },
    onCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    onSizeChange(val) {
      this.pageSize = val;
      this.pageNumber = 1;
      this.getList();
    },
    // 查询参数处理
    queryForm() {
      if (!this.orders) return [];

      // 使用 Set 一次性处理去重和过滤，减少数组操作
      const orderSet = new Set();
      this.orders.split(/\r?\n/).forEach(order => {
        const trimmed = order.trim();
        if (trimmed) {
          orderSet.add(trimmed);
        }
      });

      // 转换为数组并限制数量
      return Array.from(orderSet).slice(0, 1000);
    },
    // 重置
    clearForm() {
      this.orders = '';
      this.pageNumber = 1;
      this.pageSize = 20;
      this.tableData = [];
      this.total = 0;
    },
    // 查询列表
    async getList() {
      try {
        this.loading = true;

        const transportNumbers = this.queryForm();
        // if (!transportNumbers.length) {
        //   this.tableData = [];
        //   this.total = 0;
        //   return;
        // }

        const data = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          params: {
            transportNumberList: transportNumbers
          }
        };

        const res = await apiPayableTransportExpenseGetUnreturnedTransportOrders(data);

        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        }
      } catch (error) {
        this.$message.error('查询失败，请稍后重试');
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 对话框关闭处理
    handleDialogClose() {
      this.clearForm();
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  font-size: 16px;
  font-weight: 700;
  margin-right: 10px;
}
.feet-r {
  align-items: flex-start;
}
</style>
